export default {
  name: "ExportXslxDialog",
  props: ["customPoiImageTypes", "exportXlsx"],
  data: () => ({
    dialog: false,
    imageTypes: ["1. Bild"],
    imageType: "1. Bild"
  }),
  mounted() {
    this.imageTypes = this.imageTypes.concat(this.customPoiImageTypes);
  },
  methods: {
    closeDialogAndExport() {
      this.exportXlsx(this.imageType);
      this.dialog = false;
    }
  }
};
